import { render, staticRenderFns } from "./TextFieldComponent.vue?vue&type=template&id=6f80bb1e&scoped=true"
import script from "./TextFieldComponent.vue?vue&type=script&lang=js"
export * from "./TextFieldComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80bb1e",
  null
  
)

export default component.exports